export default [
  {
    "key": "Signup Button",
    "condition": {
      "$and": [
        {
          "query": [
            "action",
            {
              "property": "~n"
            },
            "button click"
          ]
        },
        {
          "$and": [
            {
              "query": [
                "action",
                {
                  "property": "url"
                },
                [
                  "contains",
                  "/signup"
                ]
              ]
            }
          ]
        }
      ]
    },
    "properties": [],
    "id": 399
  },
  {
    "key": "test pv",
    "condition": {
      "$and": [
        {
          "query": [
            "action",
            {
              "property": "~n"
            },
            "pv"
          ]
        },
        {
          "$and": [
            {
              "query": [
                "dom",
                {
                  "target": "content",
                  "selector": "title"
                },
                [
                  "match",
                  "Test"
                ]
              ]
            }
          ]
        }
      ]
    },
    "properties": [],
    "id": 400
  }
];